/// <reference path = "../../node_modules/@types/jquery/index.d.ts" />
/// <reference path = "../../node_modules/@types/jqueryui/index.d.ts" />

import { aboutUsAnimation } from "./about_us";
import { bannerSmokeEffect, videoMuteBtn } from "./banner";

jQuery(document).ready(function () {
  // console.info('hello world');

  bannerSmokeEffect();

  // image effect on show
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
        observer.unobserve(entry.target); // Stop observing after adding the class
      }
    });
  });

  let images = document.querySelectorAll(".image-cover-effect") as NodeList;
  images.forEach((image: HTMLElement) => {
    observer.observe(image);
  });

  // separator effect
  let dividers = document.querySelectorAll(".divider") as NodeList;
  dividers.forEach((divider: HTMLElement) => {
    observer.observe(divider);
  });

  aboutUsAnimation();
  videoMuteBtn();
});
